import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
var marginAutoOffsets = {
  left: css(["margin-left:auto;"]),
  both: css(["margin-left:auto;margin-right:auto;"]),
  right: css(["margin-right:auto;"])
};

var getWidth = function getWidth(spread) {
  return spread / 12 * 100 + "%";
};

var getSpreadProperties = function getSpreadProperties(props) {
  var minBreakpoint = props.minBreakpoint,
      spread = props.spread,
      spreadMobile = props.spreadMobile,
      spreadTablet = props.spreadTablet,
      spreadDesktop = props.spreadDesktop,
      spreadWidescreen = props.spreadWidescreen,
      spreadFullHD = props.spreadFullHD;

  if (!minBreakpoint && !spread && !spreadMobile && !spreadTablet && !spreadDesktop && !spreadWidescreen && !spreadFullHD) {
    return css(["@media (max-width:", "px){flex:none;width:100%;}"], theme('fannypack.layout.tabletBreakpoint'));
  }

  var getProperties = function getProperties(_ref) {
    var breakpoint = _ref.breakpoint,
        spread = _ref.spread;
    var properties = css(["flex:none;width:", ";"], getWidth(spread));
    if (!spread) return null;

    if (breakpoint) {
      return css(["@media (max-width:", "px){", ";}"], theme("fannypack.layout." + breakpoint), properties);
    }

    return properties;
  };

  return css(["", ";", ";", ";", ";", ";", ";", ";", ";"], getProperties({
    spread: spread
  }), getProperties({
    spread: spreadFullHD,
    breakpoint: 'fullHDBreakpoint'
  }), getProperties({
    spread: spreadWidescreen,
    breakpoint: 'widescreenBreakpoint'
  }), getProperties({
    spread: spreadDesktop,
    breakpoint: 'desktopBreakpoint'
  }), minBreakpoint !== 'tablet' && minBreakpoint !== 'mobile' && !spreadTablet && !spreadMobile && css(["@media (max-width:", "px){width:100%;}"], theme('fannypack.layout.tabletBreakpoint')), getProperties({
    spread: spreadTablet,
    breakpoint: 'tabletBreakpoint'
  }), minBreakpoint !== 'mobile' && !spreadMobile && css(["@media (max-width:", "px){width:100%;}"], theme('fannypack.layout.mobileBreakpoint')), getProperties({
    spread: spreadMobile,
    breakpoint: 'mobileBreakpoint'
  }));
};

var getSpreadOffsetProperties = function getSpreadOffsetProperties(props) {
  var spreadOffset = props.spreadOffset,
      spreadMobileOffset = props.spreadMobileOffset,
      spreadTabletOffset = props.spreadTabletOffset,
      spreadDesktopOffset = props.spreadDesktopOffset,
      spreadWidescreenOffset = props.spreadWidescreenOffset,
      spreadFullHDOffset = props.spreadFullHDOffset;

  if (!spreadOffset && !spreadMobileOffset && !spreadTabletOffset && !spreadDesktopOffset && !spreadWidescreenOffset && !spreadFullHDOffset) {
    return null;
  }

  var getProperties = function getProperties(_ref2) {
    var breakpoint = _ref2.breakpoint,
        spreadOffset = _ref2.spreadOffset;
    var properties = css(["margin-left:", ";"], getWidth(spreadOffset));
    if (!spreadOffset) return null;

    if (breakpoint) {
      return css(["@media (max-width:", "px){", ";}"], theme("fannypack.layout." + breakpoint), properties);
    }

    return properties;
  };

  if (typeof spreadOffset === 'number') {
    return css(["", ";", ";", ";", ";", ";", ";", ";", ";"], getProperties({
      spreadOffset: spreadOffset
    }), getProperties({
      spreadOffset: spreadFullHDOffset,
      breakpoint: 'fullHDBreakpoint'
    }), getProperties({
      spreadOffset: spreadWidescreenOffset,
      breakpoint: 'widescreenBreakpoint'
    }), getProperties({
      spreadOffset: spreadDesktopOffset,
      breakpoint: 'desktopBreakpoint'
    }), !spreadTabletOffset && !spreadMobileOffset && css(["@media (max-width:", "px){margin-left:0;}"], theme('fannypack.layout.tabletBreakpoint')), getProperties({
      spreadOffset: spreadTabletOffset,
      breakpoint: 'tabletBreakpoint'
    }), !spreadMobileOffset && css(["@media (max-width:", "px){margin-left:0;}"], theme('fannypack.layout.mobileBreakpoint')), getProperties({
      spreadOffset: spreadMobileOffset,
      breakpoint: 'mobileBreakpoint'
    }));
  }

  return marginAutoOffsets[spreadOffset];
};

var Column = styled(Box).withConfig({
  displayName: "styled__Column",
  componentId: "sc-1lmgd0f-0"
})(["flex:1;max-width:100%;", ";&{", ";}&{", ";}&{", ";}"], function (props) {
  return !props.isGapless ? css(["padding:", "rem;"], theme('fannypack.layout.gapFactor')) : null;
}, getSpreadProperties, getSpreadOffsetProperties, theme('fannypack.Column.base'));
export default Column;
export { Column, getSpreadOffsetProperties, getSpreadProperties, getWidth, marginAutoOffsets };